var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullStar = function SvgFullStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3138 10.3265C11.2459 9.92744 11.3744 9.52014 11.6592 9.23207L15 5.78471L10.4354 5.08235C10.0183 5.01553 9.6613 4.74694 9.48198 4.36499L7.5 0.111084L5.51802 4.36424C5.3389 4.74648 4.98187 5.01538 4.56456 5.08235L0 5.78396L3.34084 9.23207C3.62561 9.52014 3.75414 9.92744 3.68619 10.3265L2.91291 15.1111L6.88438 12.8998C7.26711 12.6869 7.73289 12.6869 8.11562 12.8998L12.0871 15.1111L11.3138 10.3265Z",
    fill: "#FFC800"
  })));
};
export default SvgFullStar;